import { Theme } from '../../ITheme';
import crashTheme from '../../crash.theme';

const skyxNewTheme: Theme = {
  ...crashTheme,
  colors: {
    ...crashTheme.colors,
    background: '#170550',
    background2: '#330774',
    background3: '#19003b',
    background4: '#9a65f7',
    primary: '#680bb9',
    secondary: '#0e0430',
    text: '#f2ecff',
    text2: '#d5c8ff',
    betborder: '#73ff49',
    betbutton: '#60ce12',
    betIdle: '#60ce12',
    betButtonHover: '#84f028',
    betHover: '#7a39ff66',
    betCancel: '#f01f1f',
    cancelborder: '#ea3434',
    betCashout: '#fff21e',
    cashoutborder: '#fff251',
    slider: '#4b1d9e',
    qbet: '#4b1d9e',
    msgBg: 'rgba(61, 15, 122, 0.84)',
    multiplierBase: '#ffffff',
    multiplierLow: '#ffffff',
    multiplierMedium: '#b370c5',
    multiplierHigh: '#ea3ed1',
  },
  fonts: {
    ...crashTheme.fonts,
    primary: "'Roboto Condensed', 'Roboto', sans-serif",
    button: "'Roboto Condensed', 'Roboto', sans-serif",
  },
};

export default skyxNewTheme;
